import { Pipe, PipeTransform } from '@angular/core';
import {
  formatDocumento,
  normalizeDocumento
} from '../shared/validators/cpf-cnpj.utils';

@Pipe({
  name: 'person',
  standalone: false
})
export class PersonPipe implements PipeTransform {

  transform(value: any): any {
    if (
      value === '' ||
      value === null ||
      value === undefined
    ) {
      return value;
    }

    const documento =
      normalizeDocumento(value);

    if (!documento) {
      return value;
    }

    return (
      formatDocumento(documento) ??
      documento
    );
  }
}